/**
 * Light a color function
 * @param {*} hex 
 * @param {*} percent 
 * @returns hex color but lighter
 */

export const lightColor = (hex, percent) => {
    const num = parseInt(hex.slice(1), 16);
    const amt = Math.round(2.55 * percent);
    const r = (num >> 16) + amt;
    const g = (num >> 8 & 0x00FF) + amt;
    const b = (num & 0x0000FF) + amt;
    return "#" + (0x1000000 + (r > 255 ? 255 : r) * 0x10000 + (g > 255 ? 255 : g) * 0x100 + (b > 255 ? 255 : b)).toString(16).slice(1);
}